module.exports = __webpack_public_path__ + "static/img/2_1_1.c6f0b48c.jpg";